import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting/asset-request`

// *** นว จัดการคำขอจองครุภัณฑ์ start
export const getAssetBookingManagement = (pageNumber = 0, pageSize = 0) => {
  const url = `${API_ROOT_VER}/reserved/manage-request-list/schema/${pageNumber}/${pageSize}`
  return doGet(url)
}

export const searchAssetBookingManagement = (request, pageNumber = 0, pageSize = 0) => {
  const url = `${API_ROOT_VER}/reserved/manage-request-list/search/${pageNumber}/${pageSize}`
  return doPost(url, request)
}

export const getAssetBookingManagementDetail = (id, pageNumber = 0, pageSize = 0) => {
  const url = `${API_ROOT_VER}/reserve/manage/schema/${pageNumber}/${pageSize}?id=${id}`
  return doGet(url)
}

export const getAssetBookingManagementSearchForm = (id = '', pageNumber = 0, pageSize = 0) => {
  const url = `${API_ROOT_VER}/reserve/asset/schema/${pageNumber}/${pageSize}?id=${id}`
  return doGet(url)
}

export const searchAssetBookingManagementSearchForm = (
  request,
  id = '',
  pageNumber = 0,
  pageSize = 0
) => {
  const url = `${API_ROOT_VER}/reserve/asset/search/${pageNumber}/${pageSize}?id=${id}`
  return doPost(url, request)
}

export const savehAssetBookingManagementDetail = (request) => {
  // http://localhost:9014/api/v1/accounting/asset-request/reserve/save
  const url = `${API_ROOT_VER}/reserve/save`
  return doPost(url, request)
}
// *** นว จัดการคำขอจองครุภัณฑ์ end

export const getReserveDocumentBooking = (id = '') => {
  // /api/files/{id}/asset/reserve/form

  const url = `${API_ROOT}/files/${id}/asset/reserve/form`
  return doDownload(url)
}
